import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccuracyTierUpdateSearchComponent } from './accuracy-tier-update-search.component';
import { IsIncludedPipeModule } from 'src/app/shared/pipes/is-included';
import {  MatTooltipModule } from '@angular/material/tooltip';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
  declarations: [
    AccuracyTierUpdateSearchComponent
  ],
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule,
        IsIncludedPipeModule,
        MatTooltipModule
    ],
  exports: [
    AccuracyTierUpdateSearchComponent
  ]
})
export class AccuracyTierUpdateSearchModule { }
